"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Thumbnails Position',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.oneRow && styleParams.hasThumbnails;
  },
  type: _constants.INPUT_TYPES.TEXT,
  "default": _constants.GALLERY_CONSTS.thumbnailsAlignment.BOTTOM,
  description: "Set the position of the sliding thumbnails relative to the gallery (bottom, top, left and right).\n  "
};
exports["default"] = _default;